// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orwi-action {
  /*     width: 100%;
    position: fixed;
    z-index: 1000;
    background-color: var(--orwi-dialog-color);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #ab0000;
    font-size: 30px;
    flex-direction: column;
    height: 100%;
    padding-top: 10px;
    overflow: hidden; */
  width: 100%;
  position: fixed;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #ab0000;
  font-size: 30px;
  flex-direction: column;
  height: 100%;
  padding-top: 10px;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);
}

@media (prefers-color-scheme: dark) {
  /*
   * Dark Colors
   * -------------------------------------------
   */
  .orwi-action {
    background-color: rgba(0, 0, 0, 0.62);
    color: white;
  }
}
.top {
  top: 0px;
  box-shadow: var(--orwi-modal-top-shadow);
  border-radius: 0px 0px 30px 30px;
}

.bottom {
  bottom: 0px;
  box-shadow: var(--orwi-modal-bottom-shadow);
  border-radius: 30px 30px 0px 0px;
  padding-bottom: 20px;
}

.orwi-actio-backdrop {
  background-color: rgba(171, 172, 173, 0.6196078431);
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 100;
  top: 0px;
}

.resizer {
  position: absolute;
  top: 8px;
  height: 5px;
  width: 50%;
  background-color: var(--orwi-modal-resizer);
  border-radius: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ui/orwi-modal/orwi-modal.component.scss"],"names":[],"mappings":"AAAA;EACE;;;;;;;;;;;;uBAAA;EAcA,WAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,mCAAA;UAAA,2BAAA;AAAF;;AAIA;EACI;;;IAAA;EAKC;IACG,qCAAA;IACA,YAAA;EAFN;AACF;AAMA;EACE,QAAA;EACA,wCAAA;EACA,gCAAA;AAJF;;AAOA;EACE,WAAA;EACA,2CAAA;EACA,gCAAA;EACA,oBAAA;AAJF;;AAOA;EACE,mDAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AAJF;;AAOA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;AAJF","sourcesContent":[".orwi-action {\n  /*     width: 100%;\n    position: fixed;\n    z-index: 1000;\n    background-color: var(--orwi-dialog-color);\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    color: #ab0000;\n    font-size: 30px;\n    flex-direction: column;\n    height: 100%;\n    padding-top: 10px;\n    overflow: hidden; */\n\n  width: 100%;\n  position: fixed;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: #ab0000;\n  font-size: 30px;\n  flex-direction: column;\n  height: 100%;\n  padding-top: 10px;\n  overflow: hidden;\n  background-color: rgba(255, 255, 255, 0.5);\n  backdrop-filter: blur(15px);\n}\n\n\n@media (prefers-color-scheme: dark) {\n    /*\n     * Dark Colors\n     * -------------------------------------------\n     */\n\n     .orwi-action  {\n        background-color: rgb(0 0 0 / 62%);\n        color: white;\n      }\n  }\n\n\n.top {\n  top: 0px;\n  box-shadow: var(--orwi-modal-top-shadow);\n  border-radius: 0px 0px 30px 30px;\n}\n\n.bottom {\n  bottom: 0px;\n  box-shadow: var(--orwi-modal-bottom-shadow);\n  border-radius: 30px 30px 0px 0px;\n  padding-bottom: 20px;\n}\n\n.orwi-actio-backdrop {\n  background-color: #abacad9e;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 100;\n  top: 0px;\n}\n\n.resizer {\n  position: absolute;\n  top: 8px;\n  height: 5px;\n  width: 50%;\n  background-color: var(--orwi-modal-resizer);\n  border-radius: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
